import { z } from "zod";

export const DiscountSchema = z.object({
	consumed_at: z.string().nullable(),
	discount_code: z.string(),
});
export type DiscountCode = z.infer<typeof DiscountSchema>;
